import { api } from "@services/api";
import { useEffect, useMemo } from "react";

import { useQuery } from "./use_query";

const useFetchArtistExclusions = () => {
  const apiCall = useMemo(() => {
    return (token: string) => () => api.artistExclusions.index(token);
  }, []);
  const {
    data: artistExclusions,
    fetchData,
    loading,
    error,
  } = useQuery(apiCall);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    artistExclusions,
    loading,
    error,
  };
};

export { useFetchArtistExclusions };
